import { UserValidator } from '@shoflo-rundown/polymer.legacy';

import React from 'react';
import _ from 'underscore';

export default {
  firstName: UserValidator.name,
  lastName: UserValidator.name,
  email: UserValidator.email,
  passwordLength: UserValidator.passwordLength,
  passwordCase: UserValidator.passwordCase,
  passwordSymbols: UserValidator.passwordSymbols,
  passwordNumbers: UserValidator.passwordNumbers,

  userForm(field, value, state) {
    let style = 'error';
    let validation = '';
    let userPasswordTooltipValidation = [
      {
        valid: true,
        message: 'At least 12 characters',
      },
      {
        valid: true,
        message: 'An uppercase & lowercase letter',
      },
      {
        valid: true,
        message: 'At least one symbol (!@#$%^&*())',
      },
      {
        valid: true,
        message: 'At least one number',
      },
    ];

    if (field === 'userFirstName') {
      if (value.length < 2) {
        style = 'error';
        validation = ' (Min limit 2 characters)';
      } else if (value.length > 100) {
        style = 'error';
        validation = ' (Max limit 100 characters)';
      } else {
        style = 'success';
      }
    }

    if (field === 'userLastName') {
      if (value.length < 2) {
        style = 'error';
        validation = ' (Min limit 2 characters)';
      } else if (value.length > 100) {
        style = 'error';
        validation = ' (Max limit 100 characters)';
      } else {
        style = 'success';
      }
    }

    if (field === 'userEmail') {
      validation = '';

      if (value.exists === true) {
        style = 'error';
        validation = (
          <span>
            {' '}
            (This email is taken. Login{' '}
            <a
              href="https://studio.app.cvent.com/login"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>
            , or try a different email)
          </span>
        );
      } else if (!this.email(value)) {
        style = 'error';
        validation = ' (Not valid email)';
      } else {
        style = 'success';
      }
    }

    if (field === 'userPassword') {
      validation = '';

      style = 'error';
      userPasswordTooltipValidation =
        UserValidator.getPasswordTooltipValidation(value);

      if (_.all(userPasswordTooltipValidation, (obj) => obj.valid)) {
        style = 'success';
      }

      state = state.set(
        'userPasswordTooltipValidation',
        userPasswordTooltipValidation,
      );

      if (state.get('userPassword2') && value !== state.get('userPassword2')) {
        style = 'error';
        validation = [' (Password does not match)'];
      }
    }

    if (field === 'userPassword2') {
      validation = '';

      if (value !== state.get('userPassword')) {
        style = 'error';
        validation = ' (Password does not match)';
      } else {
        style = 'success';
      }

      state = this.userForm('userPassword', state.get('userPassword'), state);
    }

    state = state
      .set(field + 'Style', style)
      .set(field + 'Validation', validation);

    let userFirstNameStyle = state.get('userFirstNameStyle');
    let userLastNameStyle = state.get('userLastNameStyle');
    let userEmailStyle = state.get('userEmailStyle');
    let userPasswordStyle = state.get('userPasswordStyle');
    let userPassword2Style = state.get('userPassword2Style');

    if (
      userFirstNameStyle === 'error' ||
      userLastNameStyle === 'error' ||
      userEmailStyle === 'error' ||
      userPasswordStyle === 'error' ||
      userPassword2Style === 'error'
    ) {
      state = state.delete('userFormIsValid');
    } else if (
      userFirstNameStyle &&
      userLastNameStyle &&
      userEmailStyle &&
      userPasswordStyle &&
      userPassword2Style
    ) {
      state = state.set('userFormIsValid', true);
    }

    return state;
  },

  confirmPassword(password1, password2) {
    return password1 === password2;
  },
};
